import React, { useContext } from "react";
import { FolderViewProps, EventType } from "../types";
import { PhotoManagerContext } from "..";
import SubFolders from "./SubFolders";
import Events from "./Events";
import Breadcrumbs from "../Breadcrumbs";
import Pagination from "../Pagination";
import Telemetry from "../../../../utils/rudderstackAnalytics";
import {
  decodeEntityPath,
  getEncodedEntityPath,
  getEntitySegment
} from "../FolderFeatures/EncryptionOfFolder";

const FolderView: React.FC<FolderViewProps> = ({
  folders,
  events,
  onFolderClick,
  onClickCreateSubFolder,
  onCreateEventClick,
  parentFolder,
  handleEventClick,
  albumLoadingId,
  showActionTooltip,
  setActiveShareModalEventId,
  setMarkUploadCompletePopup,
  setPrivacyPopupId,
  currentPage,
  nextPage,
  handlePageChange,
  loading
}) => {
  const context = useContext(PhotoManagerContext);

  const handleEventClickWithNavigation = (event: EventType) => {
    Telemetry.track("content-library:event-opened", {
      source: "main-panel"
    });
    const url = new URL(window.location.href);
    const encodedPath = url.searchParams.get("p");
    const segment = getEntitySegment(event);
    const decodedPath = encodedPath ? decodeEntityPath(encodedPath) : "";
    const newPath = decodedPath ? `${decodedPath}/${segment}` : segment;
    const newEncodedPath = getEncodedEntityPath(newPath);
    if (newEncodedPath) {
      context?.setEncodedString(newEncodedPath);
      handleEventClick(event, newEncodedPath);
    }
  };
  const showSubFolders =
    folders.length > 0 || parentFolder?.canCreateFolders;

  return (
    <div>
      <Breadcrumbs viewType="Folder" />
      {showSubFolders && (
        <SubFolders
          folders={folders}
          onFolderClick={onFolderClick}
          onClickCreateSubFolder={onClickCreateSubFolder}
          canCreateFolders={parentFolder?.canCreateFolders}
        />
      )}
      <Events
        events={events}
        albumLoadingId={albumLoadingId}
        showActionTooltip={showActionTooltip}
        handleEventClickWithNavigation={handleEventClickWithNavigation}
        setActiveShareModalEventId={setActiveShareModalEventId}
        setMarkUploadCompletePopup={setMarkUploadCompletePopup}
        setPrivacyPopupId={setPrivacyPopupId}
      />
      {currentPage && handlePageChange && (
        <Pagination
          currentPage={currentPage}
          nextPage={nextPage}
          handlePageChange={handlePageChange}
          loading={loading}
        />
      )}
    </div>
  );
};

export default FolderView;
